@for (plot of plotList(); track plot.originalObject.cacheId) {
  <button
    (click)="selectObject(plot.originalObject)"
    (keydown.enter)="selectObject(plot.originalObject)"
    tabindex="0"
    data-testid="object-row"
    class="flex items-center !text-p1b bg-primary-accumin-black-05 text-primary-accumin-purple-100 rounded-lg mb-1 p-3 cursor-pointer transition-colors duration-200 hover:bg-accumin-sky-100 hover:text-primary-accumin-purple-100 w-full text-left focus:outline-none focus:ring-2 focus:ring-primary-accumin-purple-100"
  >
    <div class="flex justify-between w-full">
      <div class="flex items-center">
        @if (plot.tinyPlotNumber) {
          <span>{{ "Module.Plot.TinyPlotNumber" | transloco }}: {{ plot.tinyPlotNumber }}</span>
        }
        @if (plot.area) {
          <div class="text-primary-accumin-black-25 mx-2">|</div>
          <span>{{ plot.area | translocoDecimal: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }} m²</span>
        }
      </div>

      @if (plot.isCache) {
        <div class="flex items-center gap-2 ml-4">
          <span class="text-primary-accumin-black-25 text-p1b">{{ plot.creationDateTime | formatDate }}</span>
          <mat-icon
            data-testid="cache-icon"
            svgIcon="icn-restore"
            class="inline !w-5 !h-5 mr-2 text-primary-accumin-purple-100"
            [matTooltip]="'Module.Cache.RequestFromCache' | transloco"
          />
        </div>
      }
    </div>
  </button>
} @empty {
  <div class="bg-primary-accumin-black-05 text-primary-accumin-black-50 font-medium rounded-lg mb-1 p-3 w-full text-left">
    <span>{{ "General.NoData" | transloco }}</span>
  </div>
}
